export default __webpack_public_path__ + "static/media/chair2.ab10380f.png";